export default "__VITE_ASSET__490116e9__"